
  <!--[height]="470"-->
<kendo-grid #customarAddressGrid
            [data]="customarAddressGridView"
            class="customarAddressGridCls pwaAddressGrid"
            [sortable]="true"
            [selectable]="false"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="false"
            [sort]="addressGridstate.sort"
            [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
            [pageSize]="addressGridstate.take"
            [skip]="addressGridstate.skip"
            [columnMenu]="false"
            (sort)="customerAddressGridSortChange($event)"
            (pageChange)="customerAddressGridPageChange($event)"
            (dataStateChange)="customerAddressDataStateChange($event)"
            [filter]="addressGridstate.filter"
            [loading]="gridSettings.gridLoading" *ngIf="!hideShippingAddrGrid" style="overflow: visible; height: auto; display:block;">
  <ng-template kendoGridToolbarTemplate>
    <!---->
    <button kendoButton class="buttonSize addShippingBtn" type="button" (click)="addShippingDialogOpen()">
      <span class="k-icon k-i-plus-outline"></span> &nbsp; {{lblText.addAddressLbl?lblText.addAddressLbl:customarAddress.addAddressLbl}}
    </button>
    <button kendoButton class="buttonSize manageBtn hidemanageAddressBtnPwa" (click)="manageAddressDialogOpen()" type="button">
      <span>
        <img class="imgIcon" src="../../../../assets/images/shipping-icons/icons8-truck-50.png" />
      </span> &nbsp;
      {{lblText.manageAddressLbl?lblText.manageAddressLbl:customarAddress.manageAddressLbl}}
    </button>
    <input placeholder="Search in all columns..."
           kendoTextBox
           (input)="onFilter($event.target.value)" class="pwaSearch" />

  </ng-template>

  <kendo-grid-column media="(min-width: 1050px)" field="selectonSwitch" title="{{lblText.selectAddressLbl?lblText.selectAddressLbl:customarAddress.selectAddressLbl}}" [width]="100" [filterable]="false">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <input type="radio" kendoRadioButton id="{{dataItem.id}}" [checked]="dataItem.isSelected===true? true: false"
             (change)="selectShippingAddress(dataItem)" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column media="(min-width: 1050px)" field="customerNumber" title="{{lblText.customerNumberLbl?lblText.customerNumberLbl:customarAddress.customerNumberLbl}}" [filterable]="true">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(max-width: 1024px)" title="Shipping Addresses">
    <ng-template kendoGridCellTemplate let-dataItem>

      <div class="row">
        <div style="width:100%">
          <div class="row" style="width:100%">
            <div class="col-11 title-bold">
              <!--bold-->
              {{dataItem.customerNumber}}-{{dataItem?.mailingName}}
            </div>
            <div class="col-1 paddingZero">
              <input type="radio" kendoRadioButton id="{{dataItem.id}}" [checked]="dataItem.isSelected===true? true: false"
                     (change)="selectShippingAddress(dataItem)" />
            </div>
          </div>
          <div class="row" style="width:100%">
            <div class="col-12 paddingZero">
              {{dataItem.addressLine1}}
            </div>
          </div>
          <div class="row" style="width:100%">
            <div class="col-12 paddingZero">
              {{dataItem.addressLine2}}
            </div>
          </div>
          <div class="row" style="width:100%">
            <div class="col-6 col-md-3 paddingZero">
              <span class="txt-bold">{{lblText.cityLbl?lblText.cityLbl:customarAddress.cityLbl}}:</span>

              {{dataItem.city}}
            </div>
            <div class="col-6 col-md-3 paddingZero">
              <span class="txt-bold">{{lblText.stateLbl?lblText.stateLbl:customarAddress.stateLbl}}:</span>

              {{dataItem.state}}
            </div>
            <div class="col-6 col-md-3 paddingZero">
              <span class="txt-bold">{{lblText.zipcodeLbl?lblText.zipcodeLbl:customarAddress.zipcodeLbl}}:</span>

              {{dataItem.zipCode}}
            </div>
            <div class="col-6 col-md-3 paddingZero">
              <span class="txt-bold">{{lblText.countryLbl?lblText.countryLbl:customarAddress.countryLbl}}:</span>
              {{dataItem.country}}
            </div>
          </div>
          <!--<div class="row" style="width:100%">
    <div class="col-3 paddingZero txt-bold">
      {{lblText.zipcodeLbl?lblText.zipcodeLbl:customarAddress.zipcodeLbl}}:
    </div>
    <div class="col-3 paddingZero">
      {{dataItem.zipCode}}
    </div>
    <div class="col-3 paddingZero txt-bold">
      {{lblText.countryLbl?lblText.countryLbl:customarAddress.countryLbl}}:
    </div>
    <div class="col-3 paddingZero">
      {{dataItem.country}}
    </div>
  </div>-->
          <div class="row" style="width:100%">
            <div class="col-12 paddingZero">
              <span class="txt-bold">{{lblText.phoneNumberLbl?lblText.phoneNumberLbl:customarAddress.phoneNumberLbl}}:</span>&nbsp;
              {{dataItem.phoneNumber}}
            </div>
          </div>

        </div>
      </div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="mailingName" title="{{lblText.nameLbl?lblText.nameLbl:customarAddress.nameLbl}}" [filterable]="true">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="addressLine1" title="{{lblText.addressLine1Lbl?lblText.addressLine1Lbl:customarAddress.addressLine1Lbl}}" [columnMenu]="false"
                     [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="addressLine2" title="{{lblText.addressLine2Lbl?lblText.addressLine2Lbl:customarAddress.addressLine2Lbl}}" [columnMenu]="false"
                     [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="city" title="{{lblText.cityLbl?lblText.cityLbl:customarAddress.cityLbl}}" [columnMenu]="false" [filterable]="true"
                     [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="state" title="{{lblText.stateLbl?lblText.stateLbl:customarAddress.stateLbl}}" [columnMenu]="false" [width]="100"
                     [filterable]="true">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="zipCode" media="(min-width: 1050px)" title="{{lblText.zipcodeLbl?lblText.zipcodeLbl:customarAddress.zipcodeLbl}}" [filterable]="true">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="country" media="(min-width: 1050px)" title="{{lblText.countryLbl?lblText.countryLbl:customarAddress.countryLbl}}" [filterable]="true" [width]="100">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column media="(min-width: 1050px)" field="phoneNumber" title="{{lblText.phoneNumberLbl?lblText.phoneNumberLbl:customarAddress.phoneNumberLbl}}" [columnMenu]="false"
                     [filterable]="true" [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>-->
</kendo-grid>


<section class="addShippingAdrSection">
  <kendo-dialog title="{{lblText.shippingAddressLbl?lblText.shippingAddressLbl:customarAddress.shippingAddressLbl}}" *ngIf="addShippingDialog?.opened" (close)="addShippingDialogClose()">
    <div class="shippingFormMainDiv">
      <form [formGroup]="addShippingForm" autocomplete="off">
        <div class="row" style="min-height:25px;">
          <div class="col-sm-12">
            <ul style="margin-bottom:0px; padding-left:15px;" *ngIf="showValidationInfo"><li style="color:red;"><span>{{inputValidationMessage}}</span></li></ul>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">{{lblText.nameLbl?lblText.nameLbl:customarAddress.nameLbl}}<span class="requiredField">*</span></label>
              <kendo-textbox class="form-control" name="customerName" formControlName="customerName" appInputValidator (showInfo)="showInfo($event)"
                             (blur)="validateAddShippingForm()"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidCustomerName && addShippingDialog.isSubmitted}"
                             [clearButton]="false" [maxlength]="40" tabindex="1"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.addressLine1Lbl?lblText.addressLine1Lbl:customarAddress.addressLine1Lbl}}<span class="requiredField">*</span>
              </label>
              <kendo-textbox class="form-control" name="addressLine1" formControlName="addressLine1" appInputValidator (showInfo)="showInfo($event)"
                             (blur)="validateAddShippingForm()"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidAddressLine1 && addShippingDialog.isSubmitted}"
                             [clearButton]="false" [maxlength]="35" tabindex="2"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.addressLine2Lbl?lblText.addressLine2Lbl:customarAddress.addressLine2Lbl}}
              </label>
              <kendo-textbox class="form-control" name="addressLine2" formControlName="addressLine2" appInputValidator (showInfo)="showInfo($event)"
                             [clearButton]="false" [maxlength]="35" tabindex="3"></kendo-textbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.cityLbl?lblText.cityLbl:customarAddress.cityLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-textbox class="form-control" name="city" formControlName="city" appInputValidator (showInfo)="showInfo($event)" (blur)="validateAddShippingForm()"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidCity && addShippingDialog.isSubmitted}"
                             [clearButton]="false" [maxlength]="25" tabindex="4"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.countryLbl?lblText.countryLbl:customarAddress.countryLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-dropdownlist [data]="addShippingDialog.countries" kendoTextBox class="kendoInput" [textField]="'countryName'"
                                  [valueField]="'countryCode'" name="country" formControlName="country" (blur)="validateAddShippingForm()"
                                  (selectionChange)="addShippingDialogCountySelectionChange($event)"
                                  [ngClass]="{'borderRed':addShippingDialog.isInvalidCountry && addShippingDialog.isSubmitted}"
                                  [valuePrimitive]="true" tabindex="5">
              </kendo-dropdownlist>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.stateLbl?lblText.stateLbl:customarAddress.stateLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-dropdownlist [data]="addShippingDialog.states" kendoTextBox class="kendoInput kdropdownlistAddShipping"
                                  [textField]="'stateDescription'" [valueField]="'stateCode'" name="state" formControlName="state"
                                  (blur)="validateAddShippingForm()" (selectionChange)="addShippingDialogStateSelectionChange($event)"
                                  [ngClass]="{'borderRed':addShippingDialog.isInvalidState && addShippingDialog.isSubmitted}"
                                  [valuePrimitive]="true" tabindex="6">
              </kendo-dropdownlist>

            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.zipcodeLbl?lblText.zipcodeLbl:customarAddress.zipcodeLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)" class="form-control" name="zipCode" formControlName="zipCode"
                             (blur)="validateAddShippingForm();statusCheck();"
                             [ngClass]="{'borderRed':addShippingDialog.isInvalidZipCode && addShippingDialog.isSubmitted}"
                             [clearButton]="false" maxlength="10" tabindex="7"></kendo-textbox>
              <!-- <span title="Zip code length should be minimum 10" *ngIf="addShippingForm.controls['zipCode'].hasError('minlength')" kendoTooltip class="k-icon k-i-information k-i-info spanInfoIconCls"></span> -->
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.countyLbl?lblText.countyLbl:customarAddress.countyLbl}}
              </label>
              <kendo-textbox appInputValidator (showInfo)="showInfo($event)" class="form-control" name="county" formControlName="county" tabindex="8"></kendo-textbox>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="lblCls">
                {{lblText.phoneNumberLbl?lblText.phoneNumberLbl:customarAddress.phoneNumberLbl}}<span class="requiredField">*</span>
              </label>
              <kendo-numerictextbox class="kendoInput" name="phoneNumber" formControlName="phoneNumber" [decimals]="0"
                                    [format]="'#'" [spinners]="false" (blur)="validateAddShippingForm()"
                                    [ngClass]="{'borderRed':addShippingDialog.isInvalidPhoneNumber && addShippingDialog.isSubmitted}"
                                    maxlength="10" tabindex="9"></kendo-numerictextbox>
              <span title="{{lblText.phoneValidationLbl?lblText.phoneValidationLbl:customarAddress.phoneValidationLbl}}"
                    *ngIf="addShippingDialog.isInvalidPhoneNumberMessage" kendoTooltip
                    class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
            </div>
          </div>
        </div>
        <!--<div class="row" *ngIf="duplicateAddressList?.length==0 && addShippingDialog?.isSubmitted && doDuplicateAddressCheck===false">
    <span>We could not find similar addresses as you entered, click on <b>Add New Address</b> to create new address and customer</span>
  </div>-->
        <div *ngIf="duplicateAddressList?.length>0">
          <span>{{lblText.duplicateAddressText1?lblText.duplicateAddressText1:customarAddress.duplicateAddressText1}} <b>{{lblText.zipcodeLbl?lblText.zipcodeLbl:customarAddress.zipcodeLbl}}</b> {{lblText.duplicateAddressText2?lblText.duplicateAddressText2:customarAddress.duplicateAddressText2}} <b>{{lblText.addNewAddressLbl?lblText.addNewAddressLbl:customarAddress.addNewAddressLbl}}</b>{{lblText.duplicateAddressText3?lblText.duplicateAddressText3:customarAddress.duplicateAddressText3}}</span>
          <div class="row">
            <kendo-grid [data]="duplicateAddressList"
                        [pageSize]="pageSize"
                        [skip]="skip"
                        [pageable]="true"
                        (pageChange)="pageChange($event)"
                        [selectable]="true"
                        scrollable="virtual"
                        [rowHeight]="36"
                        [height]="200">
              <kendo-grid-column media="(max-width: 1049px)" title="Matching Addresses">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="row">
                    <div style="width:100%">
                      <div class="row" style="width:100%">
                        <div class="col-12 title-bold">
                          <!--bold-->
                          {{dataItem.customerNumber}}
                        </div>
                      </div>
                      <div class="row" style="width:100%">
                        <div class="col-12 paddingZero">
                          {{dataItem.addressLine1}}
                        </div>
                      </div>
                      <div class="row" style="width:100%">
                        <div class="col-12 paddingZero">
                          {{dataItem.addressLine2}}
                        </div>
                      </div>

                      <div class="row" style="width:100%">
                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.cityLbl?lblText.cityLbl:customarAddress.cityLbl}}</span> : {{dataItem.city}}
                        </div>

                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.stateLbl?lblText.stateLbl:customarAddress.stateLbl}}</span>: {{dataItem.state}}
                        </div>
                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.zipcodeLbl?lblText.zipcodeLbl:customarAddress.zipcodeLbl}}</span> :  {{dataItem.zipCode}}
                        </div>

                        <div class="col-6 col-md-3 paddingZero">
                          <span class="txt-bold">{{lblText.countryLbl?lblText.countryLbl:customarAddress.countryLbl}}</span>: {{dataItem.country}}
                        </div>
                        <div class="col-6 col-md-3 paddingZero">
                          <button kendoButton (click)="selectExistingShippingAddress(dataItem)"
                                  class="btn-small btn btn-success">
                            {{dataItem.isActive ? (lblText.selectLbl ?lblText.selectLbl:customarAddress.selectLbl) : customarAddress.archiveSelectLbl}}
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="selectonSwitch" title="{{lblText.selectAddressLbl?lblText.selectAddressLbl:customarAddress.selectAddressLbl}}" [width]="180" [filterable]="false">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  
                  <button kendoButton (click)="selectExistingShippingAddress(dataItem)" class="btn-small btn btn-success">{{dataItem.isActive ? (lblText.selectLbl?lblText.selectLbl:customarAddress.selectLbl) : customarAddress.archiveSelectLbl}}</button>

                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="customerNumber" title="{{lblText.customerNumberLbl?lblText.customerNumberLbl:customarAddress?.customerNumberLbl}}" [filterable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="addressLine1"
                                 title="Address Line 1"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="addressLine2"
                                 title="Address Line 2"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="city"
                                 title="City"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="state"
                                 title="State"></kendo-grid-column>
              <kendo-grid-column media="(min-width: 1050px)" field="zipCode"
                                 title="Zip Code"></kendo-grid-column>
            </kendo-grid>

          </div>

        </div>
        <div class="dialog-btn-section">
          <div class="row">
            <div class="col-sm-12 float-left align-center">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button kendoButton (click)="addShippingDialogClose()" [disabled]=" saveInProcess"
                        class=" m-3 btn k-button dialogBtnSize">
                  {{lblText.closeLbl?lblText.closeLbl:customarAddress.closeLbl}}
                </button>
                <!--<button kendoButton (click)="duplicateAddressCheck(addShippingForm.value)" [disabled]=" saveInProcess" [hidden]="doDuplicateAddressCheck"
                  class=" m-3 btn k-button dialogBtnSize">
            Find
          </button>-->
                <button kendoButton (click)="addNewShippingHandler($event,addShippingForm.value)" [disabled]="isDisabled"
                        class=" m-3 btn btn-success">
                  {{lblText.addNewAddressLbl?lblText.addNewAddressLbl:customarAddress.addNewAddressLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue">
                  </kendo-loader>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </kendo-dialog>
</section>


<section>
  <kendo-dialog title="Manage Addresses" *ngIf="manageAddressDialog.opened" (close)="manageAddressDialogClose()"
                class="manageAddressDialog">
    <app-manage-address [showAddAddressBtn]="false"></app-manage-address>
  </kendo-dialog>
</section>
